import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './AnchorNavigation.css';
import React, { useState, useMemo } from 'react';
import ReactDOM from "react-dom";
import { canUseDOM, get, getColorByTheme, getDictionaryItem, getPageThemeColors, replaceWhitespace } from '../../utils';
import { useHistory } from 'react-router-dom';
// history is a transitive dependency via react-router

import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import SelectReplace from '../atoms/SelectReplace';
import NoDataSource from '../atoms/NoDataSource';
import { tealiumClickFunc, getLastPartInURL, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import { ReactComponent as ArrowIcon } from '../../resources/icons/IconChevronBottomRight.svg';
var AnchorNavigation = function AnchorNavigation(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    rendering = _ref.rendering;
  var history = useHistory();
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var items = get(fields, 'data.item.children', []);
  var dictionary = get(fields, 'data.dictionary');
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    portal = _useState2[0],
    setPortal = _useState2[1];
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  var mobileDefaultOption = getDictionaryItem(dictionary, 'mobileDefaultOption') || params && params.mobileDefaultOption;
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectValue = _useState4[0],
    setSelectValue = _useState4[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var options = useMemo(function () {
    return items.map(function (item) {
      return {
        value: replaceWhitespace(item.title && item.title.value.trim() ? item.title.value.trim() : item.name.trim()),
        label: get(item, 'title.value')
      };
    });
  }, [items]);
  React.useEffect(function () {
    if (canUseDOM && window.innerWidth <= 767) {
      var navHolder = document.querySelector('.navHolder');
      if (navHolder) {
        setPortal(navHolder);
      }
    }
    var hash = window.location.hash ? window.location.hash.slice(1) : '';
    if (hash) {
      var scrolledValue = options.find(function (option) {
        return option.value === hash;
      });
      if (scrolledValue) {
        setSelectValue(scrolledValue);
      }
      handleHashLink(history, hash);
    }
  }, []);
  if (rendering && !rendering.dataSource) {
    console.info('AnchorNavigation component render skipped. No dataSource provided');
    return pageEditing ? /*#__PURE__*/React.createElement(NoDataSource, {
      title: rendering.componentName
    }) : null;
  }
  if (!items || !items.length) {
    console.info('AnchorNavigation component render skipped. No fields provided');
    return pageEditing ? /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, " [AnchorNavigation component is empty: please provide data source]") : null;
  }
  var title = getDictionaryItem(dictionary, 'title') || params && params.title;
  if (!title) {
    console.warn('AnchorNavigation component missing a `title` parameter');
  }
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var ColorHex = get(params, 'ColorHex');
  var variables = BackgroundColorHex ? {
    "--m03-anchor-nav-primary-color": BackgroundColorHex,
    "--m03-anchor-nav-active-primary-color": ActiveColorHex,
    "--m03-anchor-nav-color": ColorHex
  } : {
    "--m03-anchor-nav-primary-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--m03-anchor-nav-active-primary-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m03-anchor-nav-color": getColorByTheme(primaryPageThemeColor)
  };
  var selectPrimaryColor = BackgroundColorHex || (primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  if (!mobileDefaultOption) {
    console.warn('AnchorNavigation component missing a `mobileDefaultOption` parameter');
  }
  function handleHashLink(history, scrollElemId) {
    if (!scrollElemId) {
      return;
    }
    var scrollElem = document.getElementById(scrollElemId);
    if (!scrollElem) {
      return;
    }

    // history.location.search, if defined, will already include the `?` character, no need to add it.
    var url = "".concat(history.location.pathname).concat(history.location.search, "#").concat(scrollElemId);
    // Use `history.push` here instead of `window.location.href` as `window.location.href` will
    // cause the page to "scroll"/jump to the named anchor value and change the browser URL bar.
    // Using just `history.push` will only change the browser URL bar, it doesn't scroll/jump to
    // the named anchor.
    // We need to manually set the scroll position due to header nav being sticky/fixed and obstructing
    // scrolled contents on both mobile and desktop.
    history.push(url);
    var timer = null;
    var scrollHandler = function scrollHandler(callback) {
      if (timer !== null) {
        clearTimeout(timer);
      }

      // execute scroll-to-anchor once when hash-click scrolling is stop (lazy load is creates this issue)
      timer = setTimeout(function () {
        scrollElem = document.getElementById(scrollElemId);
        var _filter$call = [].filter.call(document.querySelectorAll('.main-nav'), function (el) {
            return el.getBoundingClientRect().bottom > 0;
          }),
          _filter$call2 = _slicedToArray(_filter$call, 1),
          mainNav = _filter$call2[0];
        var _filter$call3 = [].filter.call(document.querySelectorAll('.navHolder > div'), function (el) {
            return el.getBoundingClientRect().top > 0;
          }),
          _filter$call4 = _slicedToArray(_filter$call3, 1),
          anchorPanel = _filter$call4[0];

        // get the main-nav height
        var anchorPanelIsVisible = anchorPanel && anchorPanel.getBoundingClientRect().bottom >= 0;
        var mainNavIsVisible = mainNav && mainNav.getBoundingClientRect().bottom >= 0;
        var mainHeight = mainNav && mainNavIsVisible ? mainNav.clientHeight : 0;
        var anchorPanelHeight = anchorPanel && anchorPanelIsVisible ? anchorPanel.clientHeight : 0;
        // calculate the position, relative to the document, of the target scroll element
        // @ts-ignore
        var rect = scrollElem.getBoundingClientRect();
        var scrollPosition = rect.top + (window.pageYOffset || document.documentElement.scrollTop);

        // scroll the window to the top of the anchor element minus the height of the nav menu and hope
        // that nothing else is in the way :)
        var scrollY = scrollPosition - mainHeight - anchorPanelHeight;
        window.scrollTo(0, scrollY);
        callback && callback();
      }, 150);
    };
    scrollHandler(function () {
      setTimeout(scrollHandler, 300);
    });
  }
  ;
  var handleSelectChange = function handleSelectChange(e) {
    setSelectValue(e);
    var scrollElemId = e.value;
    handleHashLink(history, scrollElemId);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['linkClickAnalytics'], params), scrollElemId);
  };
  var handleLinkClick = function handleLinkClick(e) {
    e.preventDefault();
    var scrollElemId = e.currentTarget.dataset.scrollid;
    handleHashLink(history, scrollElemId);
  };
  var AnchorNavigationRender = function AnchorNavigationRender() {
    return /*#__PURE__*/React.createElement(StyledWrapper, {
      rtl: rtl,
      anchorUrlParameter: params['Anchor Url Parameter']
    }, /*#__PURE__*/React.createElement("div", {
      className: "anchor-navigation",
      "data-cy": "anchor-navigation",
      style: variables
    }, /*#__PURE__*/React.createElement("h4", {
      className: "h4 anchor-navigation__heading",
      "data-cy": "anchor-navigation-heading"
    }, title), items.length ? /*#__PURE__*/React.createElement("ul", {
      className: "droplist"
    }, items.map(function (item) {
      return item.title.value.trim() ? /*#__PURE__*/React.createElement("li", {
        key: item.name,
        className: "droplist__li"
      }, /*#__PURE__*/React.createElement("a", {
        className: "droplist__a",
        onClick: function onClick(e) {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['linkClickAnalytics'], params), getLastPartInURL(item.name));
          handleLinkClick(e);
        },
        href: "#".concat(replaceWhitespace(item.title && item.title.value.trim())),
        "data-scrollid": replaceWhitespace(item.title && item.title.value.trim()),
        "data-cy": "anchor-navigation-item",
        "aria-label": replaceWhitespace(item.title && item.title.value.trim())
      }, /*#__PURE__*/React.createElement(ArrowIcon, {
        className: "icon"
      }), item.title && item.title.value.trim())) : /*#__PURE__*/React.createElement("li", {
        key: item.name,
        className: "droplist__li"
      }, /*#__PURE__*/React.createElement("a", {
        className: "droplist__a",
        onClick: function onClick(e) {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['linkClickAnalytics'], params), getLastPartInURL(item.name));
          handleLinkClick(e);
        },
        href: "#".concat(replaceWhitespace(item.name.trim())),
        "data-scrollid": replaceWhitespace(item.name.trim()),
        "data-cy": "anchor-navigation-item",
        "aria-label": replaceWhitespace(item.name.trim())
      }, item.title && item.title.value.trim()));
    })) : null, !portal && /*#__PURE__*/React.createElement("label", {
      className: "body-small anchor-navigation__label d-md-none",
      htmlFor: "jump-to-section-selector"
    }, title), items.length ? /*#__PURE__*/React.createElement("div", {
      className: "d-md-none"
    }, /*#__PURE__*/React.createElement(SelectReplace, {
      name: "jump-to-section-selector",
      id: "jump-to-section-selector",
      label: title,
      options: options,
      placeholder: mobileDefaultOption,
      changeEvent: handleSelectChange,
      componentColor: selectPrimaryColor,
      value: selectValue
    })) : null));
  };
  return portal ? /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(AnchorNavigationRender, null), portal) : /*#__PURE__*/React.createElement(AnchorNavigationRender, null);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "anchor-nav-container ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1itiq2e";
var ltrStyles = "l1sybd21";
var rtlStyles = "r1vdxxbo";
export default AnchorNavigation;